export default __webpack_public_path__ + "static/header-college-desktop-2468b8ce4fb2a7a461343cac67d5687f.svg";